module.exports = __webpack_public_path__ + "static/media/DEA_OPW_M01_01.0057e66b.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/DEA_OPW_M01_01.vtt
// module id = 520
// module chunks = 0